const CONFIG_URL = "/Config/env/env.json";

let appConfig = {};

function clean(value) {
  if (value === undefined || value === null) return "";
  return String(value).trim();
}

function getLoadedConfig() {
  if (
    typeof window !== "undefined" &&
    window.__APP_CONFIG__ &&
    typeof window.__APP_CONFIG__ === "object"
  ) {
    return window.__APP_CONFIG__;
  }

  return appConfig;
}

export function setAppConfig(config = {}) {
  appConfig = config && typeof config === "object" ? config : {};

  if (typeof window !== "undefined") {
    window.__APP_CONFIG__ = appConfig;
  }

  return appConfig;
}

export async function loadAppConfig(configUrl = CONFIG_URL) {
  if (typeof window === "undefined" || typeof fetch === "undefined") {
    return getLoadedConfig();
  }

  const response = await fetch(configUrl, { cache: "no-store" });

  if (!response.ok) {
    throw new Error(
      `[env] Nao foi possivel carregar ${configUrl}. HTTP ${response.status}`,
    );
  }

  return setAppConfig(await response.json());
}

export function getEnv(name, fallback = "") {
  const value = clean(getLoadedConfig()[name]);
  return value || fallback;
}

export function getEnvOrThrow(name) {
  const value = getEnv(name);
  if (!value) {
    throw new Error(`[env] Variavel obrigatoria ausente: ${name}`);
  }

  return value;
}
